'use strict'

import { firebaseStorage } from '@/libs/firebase'

const getSampleOrUser = async (project, uid) => {
  let xml
  if (project.type === 'sample')
    xml = await firebaseStorage.readFile(
      `sample/${project.tab}`,
      `${project.fileName}.xml`
    )
  else
    xml = await firebaseStorage.readFile(
      `project/${uid}`,
      `${project.fileName}.xml`
    )
  return Promise.resolve(xml)
}

const getSample = async (project) => {
  const xml = await firebaseStorage.readFile(
    `sample/${project.tab}`,
    `${project.fileName}.xml`
  )
  return xml
}

const setSample = async (project, xml) => {
  await firebaseStorage.writeFile(
    `sample/${project.tab}`,
    `${project.fileName}.xml`,
    xml
  )
}

const deleteSample = async (project) => {
  await firebaseStorage.deleteFile(
    `sample/${project.tab}`,
    `${project.fileName}.xml`
  )
}

const getUser = async (uid, project) => {
  const xml = await firebaseStorage.readFile(
    `project/${uid}`,
    `${project.fileName}.xml`
  )
  return xml
}

const setUser = async (uid, project, xml) => {
  await firebaseStorage.writeFile(
    `project/${uid}`,
    `${project.fileName}.xml`,
    xml
  )
}

const deleteUser = async (uid, project) => {
  await firebaseStorage.deleteFile(`project/${uid}`, `${project.fileName}.xml`)
}
const setCode = async (fileName, code) => {
  await firebaseStorage.writeFile('code/micropython', `${fileName}.py`, code)
}

export default {
  getSampleOrUser,
  getSample,
  setSample,
  deleteSample,
  getUser,
  setUser,
  deleteUser,
  setCode
}
